import { combineReducers } from "redux";

import authReducer, { IHav20AuthState, defaultAuthState } from "../auth/store/authReducer";
import contextReducer, { IContextState, defaultContextState } from "./reducers/contextReducer";

import categoryReducer, { ICategoryState, defaultCategoryState } from "./reducers/categoryReducer";
import formReducer, { IFormState, defaultFormState } from "./reducers/formReducer";
import locationReducer, { ILocationState, defaultLocationState } from "./reducers/locationReducer";
import personReducer, { IPersonState, defaultPersonState } from "./reducers/personReducer";
import observationListReducer, { IObservationListState, defaultObservationListState } from "./reducers/observationListReducer";
import observationReducer, { IObservationState, defaultObservationState } from "./reducers/observationReducer";
import permissionsReducer, { IPermissionsState, defaultCategoryPermissionState } from "./reducers/permissionsReducer";
import appRoleReducer, { IAppRoleState, defaultAppRoleState } from "./reducers/appRoleReducer";
import formContextReducer, { IFormContextState, defaultFormContextState } from "./reducers/formContextReducer";
import messageReducer, { IMessageState, defaultMessageState } from "./reducers/messageReducer";

export interface IhavainnotState {
    authentication: IHav20AuthState;
    context: IContextState;

    categories: ICategoryState;
    form: IFormState;
    locations: ILocationState;
    persons: IPersonState;
    formContext: IFormContextState;

    observationList: IObservationListState;
    permissions: IPermissionsState;
    observation: IObservationState;


    appRole: IAppRoleState;

    message: IMessageState;

}

export const initialState: IhavainnotState = {
    authentication: defaultAuthState,
    context: defaultContextState,

    categories: defaultCategoryState,
    form: defaultFormState,
    locations: defaultLocationState,
    persons: defaultPersonState,
    formContext: defaultFormContextState,

    observationList: defaultObservationListState,
    observation: defaultObservationState,

    permissions: defaultCategoryPermissionState,
    appRole: defaultAppRoleState,
    message: defaultMessageState
};

const havainnotReducer = combineReducers<IhavainnotState, any>({
    authentication: authReducer,
    context: contextReducer,

    categories: categoryReducer,
    form: formReducer,
    locations: locationReducer,
    persons: personReducer,

    observationList: observationListReducer,
    observation: observationReducer,
    permissions: permissionsReducer,
    appRole: appRoleReducer,
    formContext: formContextReducer,
    message: messageReducer
});

export default havainnotReducer;
